import moment from "moment-timezone";
import { IMaintenanceReturnResult, IOrder, isMaintenanceReturn } from "@iloq/shared";

// Note: any is used as type of orders, because Vue component
// using this will handle order.orderStatus as string instead of enum as defined in IOrder
export function filterOrdersByStatusAndAge(
  orders: any[],
  nonWantedStatus: string,
  ageInMonths: number
): IOrder[] {
  return (
    orders
      // filter out orders without timestamps first
      .filter((order) => !!order.timestamp)
      .filter(
        (order) =>
          moment().subtract(ageInMonths, "months").isBefore(moment(order.timestamp)) &&
          order.orderStatus !== nonWantedStatus
      )
  );
}

export function filterReturnsByAge(
  returns: IMaintenanceReturnResult[],
  ageInMonths: number
): IMaintenanceReturnResult[] {
  return returns.filter((r) => {
    return (
      isMaintenanceReturn(r.returnType) &&
      moment().subtract(ageInMonths, "months").isBefore(moment(r.created))
    );
  });
}
